import { z } from 'zod';

export const UserAgreementPatchBody = z.object({
  eula: z.boolean().prefault(false).describe('The EULA acceptance status of the user'),
}).describe('The body of the request to update user agreements');

export type UserAgreementPatchBody = z.infer<typeof UserAgreementPatchBody>;
